import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import HotSection from './components/HotSection';
import CategoryGrid from './components/CategoryGrid';
import LatestSection from './components/LatestSection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="韩漫网 - 免费在线漫画阅读平台，高清韩国漫画大全"
        description="韩漫网是专业的免费在线漫画阅读平台，提供高清韩国漫画大全。资源齐全，界面简洁，每日更新热门韩漫，是您休闲娱乐的可靠选择。涵盖恋爱、奇幻、动作、搞笑等多种类型高清韩漫。"
        keywords="韩漫网,免费在线漫画,高清韩国漫画大全,韩国漫画,在线漫画阅读,韩漫推荐"
        canonicalPath="/"
        ogType="website"
      />

      <Navbar />

      <main>
        <HeroSection />
        <HotSection />
        <CategoryGrid />
        <LatestSection />

        <section className="py-12 md:py-16 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
              为什么选择韩漫网？
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mt-8">
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mb-3">
                  <i className="ri-book-open-line text-xl text-primary-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900">海量资源</h3>
                <p className="text-xs text-foreground-400 mt-1">收录丰富的韩国漫画资源，涵盖各类题材</p>
              </div>
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mb-3">
                  <i className="ri-smartphone-line text-xl text-accent-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900">高清画质</h3>
                <p className="text-xs text-foreground-400 mt-1">所有漫画均为高清画质，带来最佳阅读体验</p>
              </div>
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center mb-3">
                  <i className="ri-thumb-up-line text-xl text-secondary-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900">完全免费</h3>
                <p className="text-xs text-foreground-400 mt-1">无需注册，无需付费，所有漫画免费畅读</p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="bg-background-100 rounded-lg p-8 md:p-10 flex flex-col md:flex-row items-center justify-between gap-6">
              <div>
                <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">
                  每天都有新漫画更新
                </h2>
                <p className="text-sm text-foreground-500 mt-2">收藏韩漫网，不错过任何精彩内容</p>
              </div>
              <a
                href="/category/all"
                onClick={(e) => {
                  e.preventDefault();
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                  window.location.href = '/category/all';
                }}
                className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                立即浏览
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}